export enum UsersTableColumnsTitle {
  Name = 'Name',
  Email = 'E-mail',
  Phone = 'Mobile Phone',
  Role = 'Role(s)',
  MainContact = 'Main Contact',
}

export enum UsersTableSortField {
  Name = 'fullName',
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export enum MainContactCellValue {
  True = 'Yes',
  False = '-',
}

export enum UserProfileFormInput {
  FirstName = 'First Name',
  LastName = 'Last Name',
  Phone = 'Phone',
  Email = 'Email',
  Position = 'Position',
  IsMainContact = 'Main Contact',
  SendInvitation = 'Send invitation to use this portal',
  Roles = 'Roles',
  Permissions = 'Permissions',
  PercentageOwnedOfCompany = 'Percentage Owned of Company',
  AccountStatus = 'Account Status',
}

export enum UserProfileOpenMode {
  Edit = 'Edit',
  View = 'View',
  Create = 'Create',
}

export enum IsMainContactOption {
  Yes = 'Yes',
  No = 'No',
}

export enum UserProfileFormTab {
  Roles = 'Roles',
  Permission = 'Permissions',
}

export enum AccountStatus {
  Active = 'Active',
  Pending = 'Pending',
  Disabled = 'Disabled',
}
